import DealRows from "@/components/DealRows";

const EVERYDAY_DEFS = [
  { key: "trending", title: "Trending Items", sub: "What businesses are stocking up on" },
  { key: "deals", title: "Deals For You", sub: "Biggest savings right now" },
];

const everydayHeader = (
  <div className="flex items-center gap-4">
    <div>
      <p className="mb-3 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-amber-500">
        <span className="h-px w-10 bg-amber-500" />
        Live From The Catalogue
      </p>
      <h2 className="font-display text-3xl tracking-tight text-1 sm:text-4xl" data-testid="promo-row-title">
        Trending & Deals
      </h2>
    </div>
    <span className="hidden h-px flex-1 bg-gradient-to-r from-[var(--pq-border)] to-transparent sm:block" />
    <span className="rounded-full border border-line px-3 py-1 text-[10px] font-bold uppercase tracking-[0.22em] text-3">
      Updated automatically
    </span>
  </div>
);

/**
 * EverydayDealRows — the default (non-festive) homepage deal rows:
 * Trending Items, Deals For You, and Inspired by your recent history on
 * charcoal + amber-glow panels matching the everyday hero carousel.
 */
export default function EverydayDealRows() {
  return (
    <DealRows
      defs={EVERYDAY_DEFS}
      tag="Stock Up. Stay Ready."
      panelClass="promo-row-panel"
      arrowTextClass="text-amber-600"
      testidPrefix="promo-row"
      header={everydayHeader}
    />
  );
}
